import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import palette from "../styles/palette";
import useTranslation from "../hooks/translations";
import { formatAmount } from "../utils/formatAmount";

interface PaymentSummaryProps {
  serviceCharge: number;
  orderAmount: number;
  total?: number | null;
  currency?: string | null;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  serviceCharge,
  orderAmount,
  total,
  currency,
}) => {
  const { t } = useTranslation();
  const isFree = !serviceCharge;
  const totalToPay = total ?? orderAmount + (serviceCharge || 0);

  return (
    <Box sx={{ px: 0.5, py: 1.5 }} data-testid="payment-summary">
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 0.5 }}
      >
        <Typography sx={{ fontSize: 14, color: palette.black }}>
          {t("orderAmount")}
        </Typography>
        <Typography sx={{ fontSize: 14, color: palette.black }}>
          {formatAmount(orderAmount, currency)}
        </Typography>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography sx={{ fontSize: 14, color: palette.black }}>
          {t("serviceCharge")}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: isFree ? 600 : 500,
            color: isFree ? palette.green : palette.black,
          }}
        >
          {isFree ? t("free") : formatAmount(serviceCharge, currency)}
        </Typography>
      </Grid>

      <Divider sx={{ my: 1.5 }} />

      <Grid container justifyContent="space-between" alignItems="center">
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: palette.black }}>
          {t("totalToPay")}
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: palette.primary.main,
          }}
        >
          {formatAmount(totalToPay, currency)}
        </Typography>
      </Grid>
    </Box>
  );
};

export default PaymentSummary;
